<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="familytree">
<p class="ct"><a class="xref" href="#/OEBPS/pppdrop005#toc">The Family Tree</a></p>
<p class="ah">August 1914</p>
<p class="fig"><img alt="" class="calibre3" src="OEBPS/ppp-drop-fig01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-drop007.vue?29428411